(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "vue"], factory);
	else if(typeof exports === 'object')
		exports["saas-billing"] = factory(require("lodash"), require("vue"));
	else
		root["saas-billing"] = factory(root["lodash"], root["vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_23__, __WEBPACK_EXTERNAL_MODULE_24__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition